/* ==========================================================================
   zz-pdp.js - product page enhancements. Vanilla, no libraries.
   Runs alongside zz-product.js, which already owns the gallery slide index,
   quantity buttons and the sticky bar. This file only ADDS: cursor zoom,
   lightbox, free-delivery progress, scroll progress bar, FBT add-to-cart.

   The scroll progress bar is CSS-only (animation-timeline: scroll(root)) -
   this file just injects the element, so browsers without scroll-driven
   animation simply show an empty 3px strip rather than a jittery JS bar.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- scroll progress bar ---------------- */
  if (!reduce && !document.querySelector('.zzprog')) {
    var bar = document.createElement('div');
    bar.className = 'zzprog';
    document.body.appendChild(bar);
  }

  var stage = document.querySelector('.zzg__stage');
  if (!stage) return;

  /* ---------------- cursor zoom ---------------- */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine && !reduce) {
    if (!stage.querySelector('.zzg__hint')) {
      var hint = document.createElement('span');
      hint.className = 'zzg__hint';
      hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg> Hover to zoom · click to expand';
      stage.appendChild(hint);
    }

    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      stage.style.setProperty('--zzx', ((e.clientX - r.left) / r.width * 100) + '%');
      stage.style.setProperty('--zzy', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    stage.addEventListener('mouseenter', function () { stage.classList.add('is-zoom'); });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
  }

  /* ---------------- lightbox ---------------- */
  var sources = [].map.call(document.querySelectorAll('.zzg__slide img'), function (img) {
    return img.getAttribute('src');
  });

  if (sources.length) {
    var lb = document.createElement('div');
    lb.className = 'zzlb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product image viewer');
    lb.innerHTML =
      '<button type="button" class="zzlb__close" aria-label="Close">&times;</button>' +
      (sources.length > 1
        ? '<button type="button" class="zzlb__nav zzlb__nav--prev" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 5l-7 7 7 7"/></svg></button>' +
          '<button type="button" class="zzlb__nav zzlb__nav--next" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 5l7 7-7 7"/></svg></button>' +
          '<span class="zzlb__count"></span>'
        : '') +
      '<img alt="">';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('img');
    var lbCount = lb.querySelector('.zzlb__count');
    var i = 0;
    var lastFocus = null;

    function render() {
      lbImg.setAttribute('src', sources[i]);
      if (lbCount) lbCount.textContent = (i + 1) + ' / ' + sources.length;
    }
    function open(n) {
      lastFocus = document.activeElement;
      i = n || 0;
      render();
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.zzlb__close').focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function step(d) { i = (i + d + sources.length) % sources.length; render(); }

    stage.addEventListener('click', function () {
      var active = document.querySelector('.zzg__slide.is-active');
      var idx = active ? [].indexOf.call(document.querySelectorAll('.zzg__slide'), active) : 0;
      open(idx);
    });

    lb.querySelector('.zzlb__close').addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    var p = lb.querySelector('.zzlb__nav--prev');
    var n = lb.querySelector('.zzlb__nav--next');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  /* ---------------- free delivery progress ---------------- */
  var ship = document.querySelector('[data-zz-ship]');
  if (ship) {
    var fill = ship.querySelector('[data-zz-ship-fill]');
    var text = ship.querySelector('[data-zz-ship-text]');
    var unit = parseInt(ship.dataset.zzPrice, 10) || 0;
    var goal = parseInt(ship.dataset.zzThreshold, 10) || 0;
    var qtyInput = document.querySelector('input[name="quantity"]');

    function rupees(paise) {
      return 'Rs ' + Math.ceil(paise / 100).toLocaleString('en-PK');
    }

    function draw() {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var total = unit * qty;
      var pct = goal > 0 ? Math.min(100, (total / goal) * 100) : 100;
      fill.style.width = pct + '%';
      if (total >= goal) {
        ship.classList.add('is-free');
        text.textContent = 'This order qualifies for free delivery.';
      } else {
        ship.classList.remove('is-free');
        text.textContent = 'Add ' + rupees(goal - total) + ' more for free delivery.';
      }
    }

    draw();
    if (qtyInput) {
      qtyInput.addEventListener('change', draw);
      qtyInput.addEventListener('input', draw);
    }
    document.querySelectorAll('[data-zz-qty]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(draw, 0); });
    });
  }

  /* ================================================================
     FREQUENTLY BOUGHT TOGETHER - add all in one request
     ================================================================
     >>> THIS MUST NOT NAVIGATE. <<<
     It used to end with window.location.href = '/cart', which threw the
     customer onto the cart page and out of the product they were reading.
     That contradicted the rule the rest of the site follows and the owner
     explicitly asked for: adding to cart opens the SIDE DRAWER, on desktop
     and mobile, without leaving the page.

     Nothing here opens the drawer, and nothing needs to. zz-cart.js wraps
     window.fetch and opens #cart-drawer on any successful POST to
     /cart/add - including this one. Adding an explicit drawer.open() here
     would race that hook and risk opening it twice.

     So the only job after a successful add is to put the button back.
     ================================================================ */
  var fbt = document.querySelector('[data-zz-fbt]');
  if (fbt) {
    var addBtn = fbt.querySelector('[data-zz-fbt-add]');
    if (addBtn) {
      var restoreLabel = addBtn.textContent.trim() || 'Add all to cart';
      addBtn.addEventListener('click', function () {
        var ids = (addBtn.dataset.zzIds || '').split(',').filter(Boolean);
        if (!ids.length) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            // zz-cart.js is already opening the drawer off the same request
            addBtn.textContent = 'Added to cart';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = restoreLabel;
            }, 2200);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = restoreLabel;
          });
      });
    }
  }
})();
